module.exports = __webpack_public_path__ + "static/img/bg1.d36c52c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/year2023/bg1.png
// module id = JAHq
// module chunks = 0